import { Store, Users, BarChart3, Bell, Package, TrendingUp } from "lucide-react";

const FeaturesSection = () => {
  const features = [
    {
      icon: <Store className="w-8 h-8" />,
      title: "Multi-Store Management",
      description: "Manage multiple stores from a single dashboard. Track inventory, sales, and performance across all locations."
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: "Team Collaboration",
      description: "Invite employees, assign roles, and manage permissions. Keep your team organized and productive."
    },
    {
      icon: <BarChart3 className="w-8 h-8" />,
      title: "Advanced Analytics",
      description: "Get insights into your sales, revenue, and customer behavior with comprehensive reports and dashboards."
    },
    {
      icon: <Bell className="w-8 h-8" />,
      title: "Smart Notifications",
      description: "Stay informed with real-time alerts for low stock, expiring batches, and subscription reminders via email, SMS, and push notifications."
    },
    {
      icon: <Package className="w-8 h-8" />,
      title: "Inventory Control",
      description: "Track products, manage batches, monitor expiry dates, and get alerts when stock runs low."
    },
    {
      icon: <TrendingUp className="w-8 h-8" />,
      title: "Sales Tracking",
      description: "Record sales, generate receipts, track customer purchases, and analyze sales history with detailed reports."
    }
  ];

  return (
    <section id="features" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 bg-white">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          Everything You Need to Run Your Stores
        </h2>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto">
          Powerful features designed to simplify your daily operations and boost your business performance.
        </p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {features.map((feature, index) => (
          <div
            key={index}
            className="p-6 rounded-xl border border-gray-200 hover:border-primary hover:shadow-lg transition bg-white"
          >
            <div className="text-primary mb-4">{feature.icon}</div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">{feature.title}</h3>
            <p className="text-gray-600">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturesSection;

